module.exports = "/static-assets/_next/static/images/glow-topright-4b6795f13406bf649a4b728b762659c6.png";